import * as React from "react";

import { Skeleton } from "@replo/design-system/components/skeleton/Skeleton";
import twMerge from "@replo/design-system/utils/twMerge";

export const PreviewLinkAndSVGSkeleton: React.FC = () => {
  return (
    <div className="bg-surface h-[200px] w-[200px] rounded-md">
      <Skeleton
        className="h-full w-full"
        speed={2}
        backgroundColor="#f1f5f9"
        foregroundColor="#e2e8f0"
      />
    </div>
  );
};

export const WorkspaceCardSkeleton: React.FC<{ compact?: boolean }> = ({
  compact = false,
}) => {
  return (
    <div
      className={twMerge(
        "flex items-center gap-2 box-border h-[46px] rounded-sm bg-white",
        compact && "justify-center",
      )}
    >
      <Skeleton
        className={twMerge("h-[32px] w-[32px] rounded-full")}
        speed={2}
        backgroundColor="#e2e8f0"
        foregroundColor="#cbd5e1"
      />
      {!compact && (
        <div className="flex flex-col gap-1">
          <Skeleton
            className="h-[16px] w-[140px]"
            speed={2}
            backgroundColor="#e2e8f0"
            foregroundColor="#cbd5e1"
          />
          <Skeleton
            className="h-[14px] w-[140px]"
            speed={2}
            backgroundColor="#e2e8f0"
            foregroundColor="#cbd5e1"
          />
        </div>
      )}
    </div>
  );
};
